import React from 'react';
import { PromptForMissingDatasource } from './PromptForMissingDatasource';
import { RenderingProps } from './shared.types';

type RenderingProp = RenderingProps & {
  rendering?: {
    datasource?: string;
    fields?: object;
    componentName?: string;
  };
};

type HasFieldsProp = {
  fields?: unknown;
};

type FallbackProps = {
  reason?: 'no-datasource-assigned' | 'datasource-unresolved' | 'empty-content';
  alertType?: 'info' | 'warning' | 'error' | 'success';
};

export function checkDatasourceForRendering<P extends RenderingProp & HasFieldsProp>(
  Wrapped: React.ComponentType<P>,
  fallbackDefaults: FallbackProps = { reason: 'no-datasource-assigned', alertType: 'warning' }
) {
  const ComponentWithDatasourceCheck = (props: P) => {
    const hasDatasource = !!props?.rendering?.dataSource;
    const hasFields = !!props?.fields;

    if (!hasDatasource || !hasFields) {
      return (
        <PromptForMissingDatasource
          rendering={props?.rendering}
          reason={fallbackDefaults.reason}
          alertType={fallbackDefaults.alertType}
        />
      );
    }

    return <Wrapped {...props} />;
  };

  ComponentWithDatasourceCheck.displayName = `withDatasourceCheck(${
    Wrapped.displayName || Wrapped.name || 'Component'
  })`;

  return ComponentWithDatasourceCheck;
}
